import { render, staticRenderFns } from "./Section2Widget.vue?vue&type=template&id=55a08648&lang=pug&"
import script from "./Section2Widget.vue?vue&type=script&lang=js&"
export * from "./Section2Widget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports